<template>
  <CommonBox
    :title="titles[updateType]"
    @close="$emit('close')"
    @submit="submit"
  >
    <el-form ref="form" label-width="200px" :model="initForm" :rules="rules">
      <el-form-item label="Company Name" prop="CompanyName">
        <el-input v-model="initForm.CompanyName"></el-input>
      </el-form-item>

      <el-form-item label="First Name" prop="FirstName">
        <el-input v-model="initForm.FirstName"></el-input>
      </el-form-item>

      <el-form-item label="Last Name">
        <el-input v-model="initForm.LastName"></el-input>
      </el-form-item>

      <span v-if="this.updateType === 'edit'">
        <span v-if="this.Type === '2'">
          <el-form-item label="Email" prop="Email">
            <el-input v-model="initForm.Email"></el-input>
          </el-form-item>
        </span>
        <span v-else>
          <el-form-item label="Email" prop="Email">
            <el-input v-model="initForm.Email" :disabled="true"></el-input>
          </el-form-item>
        </span>
      </span>

      <span v-if="this.updateType === 'add'">
        <el-form-item label="Email" prop="Email">
          <el-input v-model="initForm.Email"></el-input>
        </el-form-item>

        <el-form-item label="Password" prop="Password">
          <el-input v-model="initForm.Password"></el-input>
        </el-form-item>
        <br />
        <br />

        <el-form-item label="Confirm Password" prop="ConfirmPassword">
          <el-input v-model="initForm.ConfirmPassword"></el-input>
        </el-form-item>
      </span>

      <el-form-item label="Order directly ?">
          <el-select v-model="initForm.OpenOrder" placeholder="">
            <el-option
              v-for="item in openOrders"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>

      <el-form-item label="Company Website" prop="CompanyWebsite">
        <el-input v-model="initForm.CompanyWebsite"></el-input>
      </el-form-item>

      <el-form-item label="Company Description" prop="CompanyDescription">
        <el-input v-model="initForm.CompanyDescription"></el-input>
      </el-form-item>

      <el-form-item label="Country" prop="Country">
        <el-input v-model="initForm.Country"></el-input>
        
      </el-form-item>

      <el-form-item label="City" prop="City">
        <el-input v-model="initForm.City"></el-input>
      
      </el-form-item>

      <el-form-item label="Phone" prop="Phone">
        <el-input v-model="initForm.Phone"></el-input>
      </el-form-item>

      <!-- <span v-if="this.updateType === 'edit'">
                <el-form-item label="Email" prop="Email">
                    <el-input v-model="initForm.Email" :disabled="true"></el-input>
                </el-form-item> 
            </span> -->

      <el-form-item label="Grade" prop="Grade">
        <el-select v-model="initForm.Grade" placeholder="">
          <el-option
            v-for="item in grades"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="ACIA" prop="ACIA">
        <el-input v-model="initForm.ACIA"></el-input>
      </el-form-item>

      <el-form-item label="ACIP" prop="ACIP">
        <el-input v-model="initForm.ACIP"></el-input>
      </el-form-item>

      <el-form-item label="ACIE" prop="ACIE">
        <el-input v-model="initForm.ACIE"></el-input>
      </el-form-item>

      <el-form-item label="Sales Representative" prop="Account">
        <el-select v-model="initForm.Account" placeholder="" multiple>
          <el-option
            v-for="item in accountList"
            :key="item.ID"
            :label="item.AccountFullName"
            :value="item.ID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <span v-if="initForm.Grade === '4'">
        <el-form-item label="Partner" prop="Partner">
          <el-select v-model="initForm.Partner" placeholder="" multiple>
            <el-option
              v-for="item in partnerList"
              :key="item[0].ID"
              :label="item[0].PartnerFullName"
              :value="item[0].ID"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </span>

      <span v-if="initForm.Grade !== '4'">
        <el-form-item label="Distributor" prop="Partner">
          <el-select v-model="initForm.Partner" placeholder="">
            <el-option
              v-for="item in distributorList"
              :key="item[0].ID"
              :label="item[0].DistributorFullName"
              :value="item[0].ID"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </span>
    </el-form>
  </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
import { grades } from "@/utils/grade.data.js";
import { openOrders } from "@/utils/openOrder.data.js";

export default {
    components: {
        CommonBox
    },
    props: {
        updateType: {},
        initForm: {},
        type: {}
    },
    data() {
        return {
            titles: {
                add: "Add Partner",
                edit: "Edit Partner"
            },
            rules: {
                CompanyName: [
                    {
                        required: true,
                        message: "Please enter a company name",
                        trigger: "blur"
                    }
                ],
                FirstName: [
                    {
                        required: true,
                        message: "Please enter a firstName",
                        trigger: "blur"
                    }
                ],
                /* LastName:[{required: true, message: 'Please enter a lastName', trigger: 'blur'}], */
                Email: [
                    {
                        required: true,
                        message: "Please input the email address",
                        trigger: "blur"
                    },
                    {
                        type: "email",
                        message: "Please input the correct email address",
                        trigger: ["blur", "change"]
                    }
                ],
                Password: [
                    {
                        required: true,
                        message: "Please enter a correct password",
                        trigger: "blur"
                    },
                    {
                        pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{11,}$/,
                        message:
              "The password must be at least 11 characters long and contain at least three of the four types: uppercase letters, lowercase letters, special characters and digits. "
                    }
                ],
                ConfirmPassword: [
                    {
                        required: true,
                        message: "Please enter a correct password",
                        trigger: "blur"
                    },
                    {
                        pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{11,}$/,
                        message: "Two passwords are inconsistent."
                    }
                ],
                Country: [
                    {
                        required: true,
                        message: "Please enter a country",
                        trigger: "blur"
                    }
                ],
                City: [
                    { required: true, message: "Please enter a city", trigger: "blur" }
                ],
                ACIA: [
                    {
                        required: true,
                        message: "ACIA Engineer’s name. e.g. “Mark, John, Jason”",
                        trigger: "blur"
                    }
                ],
                ACIE: [
                    {
                        required: true,
                        message: "ACIE Engineer’s name. e.g. “Mark, John, Jason”",
                        trigger: "blur"
                    }
                ],
                ACIP: [
                    {
                        required: true,
                        message: "ACIP Engineer’s name. e.g. “Mark, John, Jason”",
                        trigger: "blur"
                    }
                ],
                Grade: [
                    { required: true, message: "Please select a level", trigger: "blur" }
                ],
                Account: [
                    {
                        required: true,
                        message: "Please select sales representative",
                        trigger: "blur"
                    }
                ]
            },
            grades,
            openOrders,
            Type: "",
            accountList: [],
            partnerList: [],
            distributorList: []
        };
    },
    mounted() {
        this.Type = this.type;
        this.getAccountBindingPartner();
        this.getAccountBindingDistributor();
        this.$http.get("getAllAccount", {}, (data) => {
            this.accountList = data.data;
        });
    },
    methods: {
        getAccountBindingPartner() {
            this.$http.get("getAccountBindingPartner", {}, (data) => {
                this.partnerList = data.data;
            });
        },
        getAccountBindingDistributor() {
            this.$http.get("getAccountBindingDistributor", {}, (data) => {
                this.distributorList = data.data;
            });
        },
        submit() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                let from = Object.assign({}, this.initForm);
                let methods = this.updateType === "add" ? "post" : "put";
                let url = this.updateType === "add" ? "addPartner" : "editPartner";
                this.$http[methods](url, from, (data) => {
                    this.$baseNotice.message(data.msg);
                    this.$emit("close");
                    this.$emit("update");
                });
            });
        }
    }
};
</script>
